import { render, staticRenderFns } from "./VerticalButtons.vue?vue&type=template&id=53870486&scoped=true"
import script from "./VerticalButtons.vue?vue&type=script&lang=js"
export * from "./VerticalButtons.vue?vue&type=script&lang=js"
import style0 from "./VerticalButtons.vue?vue&type=style&index=0&id=53870486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53870486",
  null
  
)

export default component.exports